import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import highlightText from "../../../utils/highlightText";
import LabelText from "../../../ui/LabelText";
import { useNavigate } from "react-router-dom";
import { useSidebar } from "../../../contexts/SidebarContext";
import { useClubSearch } from "../../../contexts/ClubSearchContext";
import noImageClub from "../../../assets/icons/noImageClub.svg";

const ClubItem: React.FC<any> = ({ item, searchText, onRemove, iconType, handleTeamChange,isForCompareTeamASrchtype }) => {
  const navigate = useNavigate();
  const { toggleSidebar, toggleDrawer } = useSidebar();
  const { setClubSearchData, setClubSearchText , clubSearchOpen , setIsClubSearchOpen } = useClubSearch();
  const [isHovered, setIsHovered] = useState(false);
  const {clubCompareId, setIsClubCompareId , setCompareClubName , setCompareClubLogoUrl}= useClubSearch()

  const handleRemove = () => {
    if (onRemove) onRemove(item);
  };

  let iconComponent;

  switch (iconType) {
    case "remove":
      iconComponent = <CloseIcon className="cta-btn-icons" onClick={handleRemove} />;
      break;
    case "image":
      iconComponent = (
        <img src={item.logoURL ? item.logoURL : noImageClub} alt={item.logoURL ? item.name : "No Image Found"} className="player-image" />
      );
      break;
    default:
      iconComponent = "";
      break;
  }

  const handleViewProfile = () => {
    const searchedItemFromStorage = localStorage.getItem("ClubSearchItem");
    let existingItems = [];
    if (searchedItemFromStorage) {
      existingItems = JSON.parse(searchedItemFromStorage);
    }
    const itemExists = existingItems.some((existingItem: any) => existingItem?.id === item.id);
    if (!itemExists) {
      existingItems.push(item);
      const updatedItemsString = JSON.stringify(existingItems);
      localStorage.setItem("ClubSearchItem", updatedItemsString);
    }
    if(isForCompareTeamASrchtype){
      setCompareClubName(item.name);
      setCompareClubLogoUrl(item.logoURL);
      setIsClubCompareId(item.id)
      setIsClubSearchOpen(false);
    }
    else{
    navigate(`/club/${item.id}`);
    }
    toggleDrawer?.(false);
    // toggleSidebar?.(false);
    setClubSearchText("");
    setClubSearchData?.([]);

  };

  return (
    <div className="club-item" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <div className="player-text-data" onClick={() => (handleTeamChange ? handleTeamChange(item.name, item.id) : handleViewProfile())}>
        {highlightText(item.name, searchText ? searchText : "")} {/* Use highlightText */}
        <LabelText className="player-team-text">{item.competitionName}</LabelText>
      </div>
      {iconComponent}
    </div>
  );
};

export default ClubItem;
